import { render, staticRenderFns } from "./carta-derechos-usuarios.vue?vue&type=template&id=6ef2d3ec&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports